<template lang="html">
  <b-carousel
    ref="imageSlide"
    style="text-shadow: 0px 0px 2px #000"
    fade
    img-height="320"
    :interval="0"
    :class="klass"
    v-if="imageURLs.length > 0"
  >
    <div>
      <b-carousel-slide
        v-for="(image, index) in imageURLs"
        :img-src="image"
        :key="index"
      ></b-carousel-slide>
      <ControlIcon
        :imageURL="`${publicImagePath}/icon_arrowleft.png`"
        :activeImageURL="`${publicImagePath}/icon_arrowleft_active.png`"
        klass="left-control"
        @on-click="moveLeft"
        v-if="!loading"
      />
      <ControlIcon
        :imageURL="`${publicImagePath}/icon_arrowright.png`"
        :activeImageURL="`${publicImagePath}/icon_arrowright_active.png`"
        klass="right-control"
        @on-click="moveRight"
        v-if="!loading"
      />
    </div>
  </b-carousel>
</template>

<script>
import ControlIcon from 'src/components/common/utility/ControlIcon.vue'

export default {
  components: { ControlIcon },
  props: ["imageURLs", "loading", "klass"],
  methods: {
    moveLeft() {
      this.$refs.imageSlide.prev();
    },
    moveRight() {
      this.$refs.imageSlide.pause()
      this.$refs.imageSlide.next();
    },
    updateSlides() {
      this.$refs.imageSlide.updateSlides()
    }
  },
}
</script>

<style lang="scss">
.carousel {
  width: 100%;
  height: 304px;

  .carousel-item {
    background-color: #EEEFFD;
    height: 304px;

    img {
      width: auto !important;
      max-width: 100%;
      max-height: 100%;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  &.compact {
    height: 192px;

    .carousel-item {
      height: 192px;
    }
  }

  @media screen and (max-width: 768px) {
    height: 240px;

    .carousel-item {
      height: 240px;
    }

    &.compact {
      height: 176px;

      .carousel-item {
        height: 176px;
      }
    }
  }
}

.left-control {
  left: 8px;
  top: calc(50% - 16px);
}

.right-control {
  right: 8px;
  top: calc(50% - 16px);
}
</style>
